// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (min-width:1000px){.openOrCloseForChart{cursor:pointer;color:#1076ff;font-size:x-small;text-decoration:underline;padding-left:93%}}@media screen and (max-width:1000px){.openOrCloseForChart{cursor:pointer;color:#1076ff;font-size:x-small;text-decoration:underline;padding-left:80%}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
